<script>
import baseMixin from '@/mixins/baseMixin'
import BaseCheckboxListSkeleton from '../skeleton/base-checkbox-list-skeleton.vue'

export default {
  name: 'LocationCertRequirementsCheckboxList',
  components: { BaseCheckboxListSkeleton },
  mixins: [baseMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    preselect: {
      type: Array,
      default: () => [],
    },
    mandatory: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    updated(selected) {
      this.$emit('updated', selected)
    },
  },
}
</script>

<template>
  <section id="create-booking-form__location-cert-requirements">
    <header>
      <h4 class="subtitle-1 mb-0">
        {{ $t('bookingCreate.formCertificationInputLabel') }}
      </h4>
      <p>
        {{ $t('bookingCreate.formCertificationInputHint') }}
      </p>
    </header>

    <BaseCheckboxListSkeleton v-if="loading" />
    <BaseCheckboxList
      v-else
      :items="items"
      :preselect="preselect"
      :disabled-items="mandatory"
      @updated="updated"
    >
      <template v-slot:label="{ label, isDisabled }">
        <v-tooltip v-if="isDisabled" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              class="d-flex align-center pointer-events-all"
              v-on="on"
            >
              {{ label }}
              <span
                data-testid="location-cert-requirements-lock-icon"
                class="ml-1 d-inline-flex"
              >
                <v-icon small color="grey darken-1">mdi-lock-outline</v-icon>
              </span>
            </span>
          </template>
          <span>{{ $t('bookingCreate.certificationRequiredTooltip') }}</span>
        </v-tooltip>
        <span v-else>{{ label }}</span>
      </template>
    </BaseCheckboxList>
  </section>
</template>
